<template>
  <div class="app">
  <backtotop/>
  <!-- Do not show navbar on landing page or login page -->
    <nav v-if="this.navEnabled() && this.$route.path !== '/' && this.$route.path !== '/login' && this.$route.path !== '/admin'">
      <knosisNavbar></knosisNavbar>
    </nav>
    <nav v-else-if="!this.navEnabled() && this.$route.path !== '/' && this.$route.path !== '/login' && this.$route.path !== '/admin'">
      <adminNavbar></adminNavbar>
    </nav>

    <!-- Need router view for routes to work -->
    <router-view></router-view>
  </div>
</template>

<script>
  import firebase from 'firebase'
  import Navbar from '@/components/Navbar'
  import backtotop from '@/components/backtotop'
  import adminNavbar from '@/components/Admin/adminNavbar'

  export default {
    components: {
      'knosisNavbar': Navbar,
      'backtotop': backtotop,
      'adminNavbar': adminNavbar
    },
    data() {
      return {
        noNavPaths: [
          '/adminMessaging',
          '/adminGroupData'
        ],
      }
    },

    methods: {
      navEnabled(){
        for(let i=0; i < this.noNavPaths.length; i++){
          if(this.$route.path === this.noNavPaths[i]){
            return false;
          }
        }
        return true;
      }
    }
  }
</script>

<style>
body, html {
  background: url(./assets/backgrounds/KNOSISBackgroundColorScheme.jpg);
  height: 100%;
  background-size: cover;
  background-attachment: scroll;
}
.app {
  background: url(./assets/backgrounds/KNOSISBackgroundColorScheme.jpg);
  height: 100%;
  background-size: cover;
  background-attachment: scroll;
}
</style>



// WEBPACK FOOTER //
// src/App.vue